// Client-safe exports for credit report types
// This file has no dependencies on MongoDB or server-side code

import type { PrequalScenario } from './prescreen'

export enum CreditReportType {
  Prequal = 'prequal',
  Dit = 'dit',
  PrequalCombined = 'prequal-combined',
  PrequalCoborrower = 'prequal-coborrower'
}

export type CreditReportData = {
  _id?: string
  source: string
  reportType: CreditReportType | string
  report: any
  request?: any
  combinedFrom?: string
  combinedWith?: string
  comboName?: string
  consumerId?: string
  principalId?: string
  prescreenRequestId?: string
  loanAppId?: string
  scenario?: PrequalScenario
  prequalResult?: string
  ditDecision?: string
}

